import { createRouter } from "@tanstack/react-router";

import {
  RouteErrorComponent,
  RouteNotFoundComponent,
  RoutePendingComponent,
} from "./defaults";
import { edgeRouteTree } from "./edge-routes";
import { routeTree } from "./routes";

/**
 * One codebase, two route trees:
 *   - cloud (default): full fleet + scope + site screens
 *   - edge  (`--mode edge`): site-scoped subset for the LAN/edge artifact (X3)
 *
 * The mode is baked at build time by Vite, so tree-shaking removes the unused
 * route tree and its screen imports from the other bundle.
 */
const isEdge = import.meta.env.MODE === "edge";

export const router = createRouter({
  routeTree: isEdge ? edgeRouteTree : routeTree,
  defaultPreload: "intent",
  // Every route gets these, so no screen has to remember to opt in. Without the
  // error one, TanStack installs NO CatchBoundary at all and a single screen
  // throwing unmounted the whole tree — rail and top bar included — leaving a
  // white page with no way back (QA, 25 Oct). The other two replace the library's
  // unstyled "Not Found" paragraph and a `null` transition fallback.
  defaultErrorComponent: RouteErrorComponent,
  defaultNotFoundComponent: RouteNotFoundComponent,
  defaultPendingComponent: RoutePendingComponent,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
